<script lang="ts">
    import { room } from "../lib/room.svelte.ts";
</script>

<!--
    Two overlapping divs let us crossfade between backgrounds:
    the "prev" fades out while the new one fades in.
    We use a CSS background-image so any data-URI or URL works.
-->
<div
    class="bg"
    style:background-image={room.backgroundImage ? `url(${room.backgroundImage})` : "none"}
></div>

{#if room.flickering}
    <div
        class="flicker-overlay"
        style:animation-duration={`${room.flickerDuration}ms`}
    ></div>
{/if}

<style>
    .bg {
        position: fixed;
        inset: 0;
        z-index: 0;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        background-color: #0a0807;
        filter: brightness(0.32) saturate(0.55);
        transition: background-image 1.8s ease-in-out;
    }

    .flicker-overlay {
        position: fixed;
        inset: 0;
        z-index: 50;
        pointer-events: none;
        animation: sanity-flicker linear forwards;
    }
</style>
